module.exports = "7a2351f099708367ef7b20ab9ce28d2b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/lantern-mid.png
// module id = 57
// module chunks = 0